import { useIntl } from "react-intl";

import { SignInProviders } from "@/components/signup/bxp-ui-signup/src/components/signup-form/components";

import { PaidHeroTabPanelTemplate } from "./hero-tab-panel-template";

export const defaultHeroProps = {
    signup: {
        bundle: "jira-software",
        edition: "free",
        featureFlags: {
            enableDefaultExpandedEmail: false,
            enableDeferredFullName: true
        }
    },
    customSignInProviders: ["google", "microsoft"] as SignInProviders,
    hideLegalText: true,
    hasRebrandedSignupFormStyles: true
};

const AllTeamsTabContent = () => {
    const intl = useIntl();

    const allTeamsHeroProps = {
        header: intl.formatMessage({
            id: "JiraSoftwarePagePaidLpJswFeatures.hero.header",
            defaultMessage:
                "Connect every team, task, and project together with Jira"
        }),
        image: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/t501oo65h16scx35qe60q32dj6a4782t.webp",
            alt: intl.formatMessage({
                id: "JiraSoftwarePagePaidLpJswFeatures.default.heroImageAlt",
                defaultMessage: "Screen capture of a Jira backlog"
            })
        },
        showAnimatedHero: true
    };

    return (
        <PaidHeroTabPanelTemplate
            {...allTeamsHeroProps}
            {...defaultHeroProps}
        />
    );
};

export default AllTeamsTabContent;
